module.exports = require("uncontrollable");


//////////////////
// WEBPACK FOOTER
// external "uncontrollable"
// module id = 18
// module chunks = 0